import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "py-16 bg-neutral-50" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "grid grid-cols-2 md:grid-cols-5 gap-5" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "w-14 h-14 rounded-xl flex items-center justify-center bg-primary-50 group-hover:bg-primary-100 transition-colors" }
const _hoisted_6 = {
  class: "w-7 h-7 text-primary-500",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_7 = ["d"]
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "font-semibold text-base text-neutral-800" }
const _hoisted_10 = { class: "text-xs mt-0.5 text-neutral-400" }
const _hoisted_11 = {
  key: 0,
  class: "inline-block w-8 h-3 bg-neutral-200 rounded animate-pulse"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12" }, [
        _createElementVNode("div", null, [
          _createElementVNode("p", { class: "text-primary-500 text-sm font-semibold uppercase tracking-widest mb-2" }, "Browse by Type"),
          _createElementVNode("h2", { class: "text-3xl md:text-4xl font-bold text-neutral-800" }, " Discover Properties ")
        ]),
        _createElementVNode("p", { class: "text-neutral-500 max-w-sm text-sm leading-relaxed" }, " Find your perfect property from our extensive collection across Rwanda ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
          return (_openBlock(), _createElementBlock("button", {
            key: category.typeFilter,
            onClick: ($event: any) => (_ctx.goToType(category)),
            class: "group relative flex flex-col items-center gap-4 p-6 rounded-2xl border-2 border-neutral-200 bg-white text-neutral-700 hover:border-primary-300 hover:shadow-md transition-all duration-200 cursor-pointer text-left"
          }, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.8",
                  d: category.icon
                }, null, 8, _hoisted_7)
              ]))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(category.label), 1),
              _createElementVNode("p", _hoisted_10, [
                (_ctx.countsLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(category.count.toLocaleString()) + " Properties ", 1)
                    ], 64))
              ])
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}